import * as React from "react";
import { toINR } from "../../../../service/numberFormat";

export interface IHoldMfUnusablePopupProps {
	data: any;
	onClose: () => void;
}

const HoldMfUnusablePopup: React.FC<IHoldMfUnusablePopupProps> = props => {
	return (
		<div className="hold_popup">
			<div>
				<button className="cls" onClick={props.onClose}>
					<i className="edel-icon-close"></i>
				</button>
			</div>
			<div className="content_lr_padding heading_cont btmborder">
				<h2 className="title">{props.data.companyName}</h2>
				{/* <h3 className="sub_title">{props.data.cpName ? props.data.cpName : props.data.dpName}</h3> */}
			</div>
			<div className="content_lr_padding">
				<div className="content_tb_padding btmborder bold">
					<div className="row">
						<span>LTP</span>
						<span>₹{toINR(props.data.LTP)}</span>
					</div>
				</div>
				<div className="content_tb_padding">
					<div className="row">
						<span>Locked-in Quantity</span>
						<span>{toINR(props.data.lockedInQty)}</span>
					</div>
					<div className="row">
						<span>Pledged Quantity</span>
						<span>{toINR(props.data.holdingValue)}</span>
					</div>
				</div>
			</div>
		</div>
	);
};

export default HoldMfUnusablePopup;
